module.exports = __webpack_public_path__ + "static/media/ChipsYellow.e30b4ec8.png";